module.exports = __webpack_public_path__ + "img/shield.c97ab3c1.svg";